import React, { useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * Snapshot of the home hero as it looked BEFORE today's changes (commit be2f84a):
 * - Original mockup image with baked-in nav overlay
 * - Site header was transparent-over-hero (light text on the dark image)
 * - No cream headroom band above the image
 *
 * This page reproduces that state by:
 * 1) Serving the ORIGINAL hero image (`hero-mockup-old.webp`)
 * 2) Temporarily forcing the site header to transparent + light text while mounted
 */
const HomeYesterdayPreview = () => {
  useEffect(() => {
    const styleEl = document.createElement("style");
    styleEl.id = "melavi-yesterday-preview-style";
    styleEl.textContent = `
      header[data-testid="site-header"] {
        background: transparent !important;
        border-bottom: none !important;
        backdrop-filter: none !important;
        color: #F6F1E9 !important;
      }
      header[data-testid="site-header"] * { color: #F6F1E9 !important; border-color: rgba(246,241,233,0.4) !important; }
      header[data-testid="site-header"] svg { fill: #F6F1E9 !important; stroke: #F6F1E9 !important; }
    `;
    document.head.appendChild(styleEl);
    return () => { styleEl.remove(); };
  }, []);

  return (
    <div data-testid="home-yesterday-preview">
      {/* Ribbon so it's obvious this is a snapshot */}
      <div
        className="fixed top-3 right-3 z-[60] px-3 py-2 text-[11px] tracking-[0.18em] uppercase"
        style={{ background: "rgba(246,241,233,0.94)", color: "#1C1A19", border: "1px solid #C9B99F" }}
      >
        Yesterday's hero · pre 2026-08-14
      </div>

      <section
        className="relative w-full overflow-hidden"
        data-testid="hero-yesterday"
        style={{ background: "#1c1512" }}
      >
        <Link to="/product/butterfly-bliss-pink" className="block" data-testid="hero-yesterday-link">
          <img
            src="/api/uploads/home/hero-mockup-old.webp"
            alt="Butterfly Bliss Pink — original hero mockup with baked-in nav"
            className="w-full h-auto block"
            data-testid="hero-yesterday-image"
          />
        </Link>
      </section>

      <div className="max-w-[900px] mx-auto px-6 md:px-12 lg:px-24 py-24">
        <div className="nav-item mb-4 text-ink/60">Snapshot</div>
        <h2 className="serif text-3xl md:text-4xl leading-tight mb-6">
          This is how the home hero looked <em className="italic">before</em> today's changes.
        </h2>
        <ul className="text-ink/80 leading-relaxed space-y-2 text-base list-disc pl-6">
          <li>Original mockup image — the second nav bar (SHOP · ABOUT · MELAVI · CRAFTSMANSHIP · CONTACT) was <em>baked into</em> the image.</li>
          <li>Site header was transparent with light cream text — sat on top of the dark image, no cream band above.</li>
          <li>Single full-bleed <code>&lt;img&gt;</code> wrapped in a <code>Link</code> to <code>/product/butterfly-bliss-pink</code>.</li>
        </ul>
        <div className="mt-10 flex gap-6">
          <Link to="/" className="crimson-link nav-item !text-[12px]">← Back to current home</Link>
        </div>
      </div>
    </div>
  );
};

export default HomeYesterdayPreview;
